import { useCallback, useEffect, useMemo, useReducer, useState } from 'react';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { fetchSuppliers, selectAllSuppliers } from '../../../slices/suppliers/suppliersSlice';
import { selectAllCompanies } from '../../../slices/companies/companiesSlice';

function reducer(state: any, action: any) {
  switch (action.type) {
    case 'setSearchString': {
      return {
        ...state,
        searchString: action.searchString,
      };
    }
  }
}

export const useSupplierProfiles = () => {
  const dispatchCustom = useAppDispatch();
  const company = useAppSelector(selectAllCompanies)[0];
  const suppliers = useAppSelector(selectAllSuppliers);
  const suppliersCount = useAppSelector((state) => state.suppliers.suppliersCount);
  const suppliersLoading = useAppSelector((state) => state.suppliers.status);
  const [cardView, setCardView] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchStringInputValue, setSearchStringInputValue] = useState('');
  const [searchCleared, setSearchCleared] = useState(false);
  const [state, dispatch] = useReducer(reducer, { searchString: '' });

  const searchParams: {
    company_id: number;
    sort?: string;
    order?: string;
    name?: string;
    page?: number;
  } = useMemo(
    () => ({
      company_id: company?.id ?? 0,
      name: state.searchString,
      sort: 'name',
      order: 'ASC',
    }),
    [company?.id, state.searchString]
  );

  const getNextPage = () => {
    dispatchCustom(
      fetchSuppliers({
        ...searchParams,
        page: currentPage + 1,
      })
    );
    setCurrentPage(currentPage + 1);
  };

  const getRequestedPage = (page: number) => {
    dispatchCustom(
      fetchSuppliers({
        ...searchParams,
        page,
      })
    );
    setCurrentPage(page);
  };

  const getPrevPage = () => {
    dispatchCustom(
      fetchSuppliers({
        ...searchParams,
        page: currentPage - 1,
      })
    );
    setCurrentPage(currentPage - 1);
  };

  const setSearchStringValue = useCallback(() => {
    if (suppliersLoading !== 'loading') {
      dispatch({ type: 'setSearchString', searchString: searchStringInputValue });
    }
  }, [suppliersLoading, searchStringInputValue]);

  const resetSearchFilter = useCallback(() => {
    dispatch({ type: 'setSearchString', searchString: '' });
    setSearchStringInputValue('');
    setSearchCleared(true);
  }, [setSearchCleared]);

  const fetchSuppliersArray = useCallback(() => {
    dispatchCustom(fetchSuppliers({ ...searchParams, page: currentPage }));
  }, [currentPage, dispatchCustom, searchParams]);

  useEffect(() => {
    setSearchStringValue();
  }, [setSearchStringValue]);

  useEffect(() => {
    fetchSuppliersArray();
  }, [fetchSuppliersArray]);

  /*useEffect(() => {
    return () => {
      resetSearchFilter();
    };
  }, [resetSearchFilter]);*/

  return {
    cardView,
    setCardView,
    suppliers,
    suppliersLoading,
    getNextPage,
    getPrevPage,
    getRequestedPage,
    currentPage,
    setCurrentPage,
    suppliersCount,
    resetSearchFilter,
    searchCleared,
    setSearchCleared,
    searchStringInputValue,
    setSearchStringInputValue,
  };
};
